/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Rationale_No_DataInputs */

const en_coach_rationale_no_data = /** @type {(inputs: Coach_Rationale_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No training history. Starting with a conservative plan of easy runs.`)
};

const de_coach_rationale_no_data = /** @type {(inputs: Coach_Rationale_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Trainingsverlauf — Start mit einem konservativen Plan aus lockeren Läufen.`)
};

/**
* | output |
* | --- |
* | "No training history. Starting with a conservative plan of easy runs." |
*
* @param {Coach_Rationale_No_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_rationale_no_data = /** @type {((inputs?: Coach_Rationale_No_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Rationale_No_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_rationale_no_data(inputs)
	return de_coach_rationale_no_data(inputs)
});